import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { EtatVide } from '../composants/EtatVide.js';
/** Mes factures (§6.6). Les PDF viendront du stockage objet, par URL signée (§7). */
export function Factures({ t }) {
    return (_jsxs(_Fragment, { children: [_jsx("h1", { className: "titre-ecran", children: t('app.mesFactures') }), _jsx(EtatVide, { titre: t('etat.vide.titre'), texte: t('etat.vide.factures') })] }));
}
//# sourceMappingURL=Factures.js.map